// extracted by mini-css-extract-plugin
export default {"cls1":"ResearcherList-cls1__f73f7d71f91d1ad58eee","cls2":"ResearcherList-cls2___796f40bf48e45702f16 ResearcherList-cls1__f73f7d71f91d1ad58eee"};